<template>
  <main class="view user">
    <h1>{{ fullName }}</h1>
    <div class="container">
      <form @submit="handleUserUpdate">
        <div class="group">
          <TextInput
            fill
            label="Vorname"
            :value.sync="form.firstname"
          />
        </div>
        <div class="group">
          <TextInput
            fill
            label="Nachname"
            :value.sync="form.lastname"
          />
        </div>
        <div class="group">
          <TextInput
            fill
            label="E-Mail Adresse"
            :value.sync="form.email"
          />
        </div>
        <div class="group">
          <TextInput
            fill
            label="Mobile Nummer"
            hint="Dient zum Senden des SMS-Codes beim Anmelden."
            :value.sync="form.phone"
          />
        </div>
        <!--
        <div class="group">
          <TextInput
            fill
            label="Titel / Job-Bezeichnung"
            hint="Wird am Ende des Berichts zur Unterschrift hinzugefügt."
            :value.sync="form.extras.title"
          />
        </div>
        <div class="group">
          <TextareaInput
            fill
            label="Notiz"
            hint="Informationen werden am Ende des Berichts ausgegeben."
            :value.sync="form.extras.note"
          />
        </div>
        -->
        <div class="group">
          <Richtext
            label="Signatur"
            hint="Bilder für Unterschriften sollten maximum 120px hoch sein."
            :legacy="{
              title: (form.extras || {}).title,
              note: (form.extras || {}).note,
            }"
            image-max-height="60px"
            :value.sync="form.extras.signature"
          />
        </div>
        <div class="group submit">
          <Button primary type="submit">Speichern</Button>
        </div>
      </form>
    </div>
    <div class="container headed">
      <h2>Neues Passwort setzen</h2>
      <form @submit="handlePasswordUpdate">
        <div class="group">
          <TextInput
            type="password"
            label="Passwort"
            :value.sync="form.password"
            :error="passwordDifferent"
            fill
          />
        </div>
        <div class="group">
          <TextInput
            type="password"
            label="Passwort wiederholen"
            :value.sync="passwordRepeat"
            :error="passwordDifferent"
            fill
          />
        </div>
        <div class="group submit">
          <Button primary type="submit">Neues Passwort setzen</Button>
        </div>
      </form>
    </div>
    <div class="container headed">
      <h2>Sonstiges</h2>
      <div class="group">
        <Button primary @click="handleLogout">Abmelden</Button>
      </div>
    </div>
  </main>
</template>

<script>
  import { Store } from '@/store';
  import TextInput from '@/components/ui/inputs/TextInput';
  import Button from '@/components/ui/inputs/Button';
  import TextareaInput from '@/components/ui/inputs/TextareaInput';
  import Richtext from '@/components/ui/inputs/Richtext';
  import Toast from '@/components/ui/Toast';

  export default {
    name: 'User',
    components: {
      Richtext,
      TextareaInput,
      Button,
      TextInput,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        form: {
          firstname: null,
          lastname: null,
          email: null,
          phone: null,
          extras: {
            note: null,
            title: null,
            signature: [],
          },
          password: null,
        },
        passwordRepeat: null,
        passwordDifferent: false,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      fullName() {
        const first = this.form.firstname;
        const last = this.form.lastname;
        if (first && last) {
          return `${first} ${last}`;
        }
        return '';
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      'form.password': {
        handler() {
          this.checkPasswords();
        },
      },
      passwordRepeat() {
        this.checkPasswords();
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    async created() {
      const user = await this.$sav.api.get(`/user/${Store.uuid}`);
      this.form = {
        firstname: user?.firstname,
        lastname: user?.lastname,
        email: user?.email,
        phone: user?.phone,
        extras: user?.extras || {},
      };
    },
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      async submitData() {
        try {
          const postdata = this.form;
          if (postdata.extras?.signature) {
            delete postdata.extras?.note;
            delete postdata.extras?.title;
          }
          const response = await this.$sav.api.patch(`/user/${Store.uuid}`, null, postdata);
          if (response) {
            if (this.form.password !== null) {
              Toast.success(this.$i18n.t('user.form.password.success'));
            } else {
              Toast.success(this.$i18n.t('user.form.data.success'));
              Store.extras = postdata.extras;
            }
          }
        } catch (err) {
          if (this.form.password !== null) {
            Toast.success(this.$i18n.t('user.form.password.error'));
          } else {
            Toast.success(this.$i18n.t('user.form.data.error'));
          }
        }
      },
      checkPasswords() {
        this.passwordDifferent = false;
        const password = this.form.password;
        const repeat = this.passwordRepeat;
        if (password !== null && repeat !== null && password !== repeat) {
          this.passwordDifferent = true;
        }
      },
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleLogout() {
        this.$emit('signout');
      },
      handleUserUpdate(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.form.password = null;
        this.passwordRepeat = null;
        this.submitData();
      },
      async handlePasswordUpdate(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.passwordRepeat === this.form.password) {
          await this.submitData();
          this.form.password = null;
          this.passwordRepeat = null;
        }
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.user {
  & > h1 {
    text-align: center;
    margin-bottom: 48px;
  }
  & > .container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-self: center;
    background-color: $color-white-solid-10;
    border-radius: $default-border-radius;
    width: 500px;
    box-shadow: 0 2px 4px rgba(16, 0, 0, 0.1);
    margin: 0 auto 48px auto;
    padding: 32px;
    outline: 0;

    &.headed {
      padding-top: 24px;
      h2 {
        margin-top: 0;
        margin-bottom: 24px;

      }
    }

    form {
      padding: 0;

      .group {
        margin-bottom: 24px;
        &.submit { margin-top: 48px; }
        &.status {
          @include font-body-small;
          &.failed, &.different { color: $color-signal-red; }
          &.success { color: $color-signal-green; }
        }
        &:last-of-type { margin-bottom: 0; }
      }

      hr {
        border: 0;
        margin: 24px 0;
        border-bottom: 1px solid $color-black-alpha-10;
      }
    }
  }
}
</style>
